import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseFocus = {
  outlineColor: 'orange',
  outlineWidth: 2,
  outlineStyle: 'solid'
};
export default {
  variants: {
    primary: {
      bg: 'primary',
      color: 'grey-0',
      hover: {
        bg: 'grey-80'
      },
      focus: _objectSpread(_objectSpread({}, baseFocus), {}, {
        bg: 'primary',
        color: 'grey-0'
      }),
      disabled: {
        bg: 'grey-20',
        color: 'grey-0'
      }
    },
    secondary: {
      bg: 'grey-05',
      color: 'primary',
      hover: {
        bg: 'grey-20'
      },
      focus: _objectSpread(_objectSpread({}, baseFocus), {}, {
        bg: 'grey-05',
        color: 'primary'
      }),
      disabled: {
        bg: 'grey-05',
        color: 'grey-40'
      }
    },
    tertiary: {
      borderColor: 'grey-0',
      borderWidth: 1,
      broderStyle: 'solid',
      bg: 'grey-0',
      color: 'primary',
      hover: {
        bg: 'grey-05'
      },
      focus: _objectSpread(_objectSpread({}, baseFocus), {}, {
        bg: 'grey-0',
        color: 'primary'
      }),
      disabled: {
        bg: 'grey-0',
        color: 'grey-40'
      }
    }
  }
};